<script>
import swal from 'sweetalert2';

export default {
    methods: {
        deleteRole(role) {
            swal({
                title: this.$trans.get('admin.common.are_you_sure'),
                text: this.$trans.get('admin.common.cannot_undo'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#dd3333',
                confirmButtonText: this.$trans.get('admin.common.confirm_delete'),
            })
                .then(reason => {
                    // Dismissed/closed
                    if (reason.hasOwnProperty('dismiss')) {
                        return;
                    }

                    this.$axios
                        .delete(
                            route('admin.roles.delete', {
                                role: role,
                            }),
                        )
                        .then(response => {
                            if (!response.data.status) {
                                swal({
                                    title: this.$trans.get('admin.common.error'),
                                    text: response.data.error,
                                    type: 'error',
                                }).catch(swal.noop);
                            } else {
                                window.location.reload();
                            }
                        });
                })
                .catch(swal.noop);
        },
    },
};
</script>
